/* eslint-disable padding-line-between-statements */
import { useModal } from '@jutro/components';
import { useTranslator } from '@jutro/locale';
import cx from 'classnames';
import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { useCallback, useEffect, useState, useContext } from 'react';
import { WizardContext } from '@xengage/gw-portals-wizard-react';
import { LoadSaveService } from 'twia-capability-quoteandbind-residential';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import messages from './WizardPageHeader.messages';
import styles from './WizardPageHeader.module.scss';
import QuoteExitPopupUtil from '../util/QuoteExitPopupUtil';
import TWIAWizardHelper from '../util/TWIAWizardHelper';

import { Link } from '@jutro/router';

const QUOTE_TRANSACTION = [
    'CommercialProperty',
    'WC7WorkersComp',
    'Homeowners',
    'BusinessOwners',
    'PersonalAuto',
    'HOPHomeowners',
];

const WizardPageHeader = props => {
    const translator = useTranslator();
    const { showConfirm } = useModal();
    const [wizardHeaderTemplate, setWizardHeaderTemplate] = useState('');
    const [routePath, setRoutePath] = useState('');
    const [accountName, setAccountName] = useState('');
    const [lobWithQuoteNumber, setLobWithQuoteNumber] = useState('');
    const { wizardSubmission, isSideHeader, lobFlow, displayWizardHeader } =
        props;
    const wizardContext = useContext(WizardContext);
    const { currentStepIndex } = wizardContext;
    const hoPolicyTypeTwia = _.get(wizardSubmission, 'lobData.homeowners.policyType_TWIA.value');
    const hoPolicyTypeTfpa = _.get(wizardSubmission, 'lobData.homeowners_tfpa.policyType_TWIA.value') 
    || _.get(wizardSubmission, 'lobData.homeowners_tfpa.coverables.policyType_Ext.value');
    const coverageFormList = _.get(wizardSubmission, 'lobData.commercialProperty.coverables.locations.value');
    const [buildcoverageForm, setbuildcoverageForm] = useState();
    const authHeader =  _.get(useAuthentication(), 'authHeader');

    useEffect(() => {
        const productCode = _.get(
            wizardSubmission.value,
            'baseData.productCode'
        );
        const jobType = _.get(wizardSubmission.value, 'baseData.jobType');
        const lob =
            (jobType === 'Renewal' && `${productCode}${jobType}`) ||
            (jobType === 'PolicyChange' && `${productCode}${jobType}`) ||
            productCode;
        const accountNumber = _.get(
            wizardSubmission.value,
            'baseData.accountNumber'
        );
        const getFirstName =
            _.get(wizardSubmission.value, 'baseData.accountHolder.firstName') ||
            '';
        const getLastName =
            _.get(wizardSubmission.value, 'baseData.accountHolder.lastName') ||
            '';
        const getDisplayName = _.get(
            wizardSubmission.value,
            'baseData.accountHolder.displayName'
        );
        const getAccountDisplayName = !getDisplayName
            ? `${getFirstName} ${getLastName}`
            : getDisplayName;
        const getAccountName =
            _.trim(getAccountDisplayName) ||
            _.get(
                wizardSubmission.value,
                'baseData.accountHolder.contactName'
            ) ||
            _.get(wizardSubmission.value, 'baseData.accountName');

        if (lob && QUOTE_TRANSACTION.includes(productCode)) {
            setWizardHeaderTemplate('transaction');
        }

        /* eslint no-underscore-dangle: 0 */
        if (wizardSubmission._dtoName.indexOf('fnol') !== -1) {
            setWizardHeaderTemplate('claim');
        }

        setRoutePath(`/accounts/${accountNumber}/summary`);
        setAccountName(getAccountName);
        
        // US26334
        if(productCode === 'Homeowners'){
            const quoteID = (jobType === 'Submission') ? _.get(wizardSubmission.value, 'quoteID') : _.get(wizardSubmission.value, 'jobID');
            const policyNumber = _.get(wizardSubmission.value, 'policyNumber');
            const jobId = _.get(wizardSubmission.value, 'jobID')
            //const policyType = _.get(wizardSubmission.value, 'lobData.homeowners.policy')

            if (hoPolicyTypeTwia) {
                if (jobType === "Renewal") { // Renewal Header title
                    setLobWithQuoteNumber(
                        translator({
                            id: `typekey.HOPolicyType_HOE.${hoPolicyTypeTwia.code}`,
                            defaultMessage: hoPolicyTypeTwia.code,
                        }).concat("\n").concat(` (${policyNumber}) - Renewal (${quoteID})`));
                } else if (jobType === 'PolicyChange' && !_.isEmpty(jobId)) {
                    setLobWithQuoteNumber(
                        translator({
                            id: `typekey.HOPolicyType_HOE.${hoPolicyTypeTwia.code}`,
                            defaultMessage: hoPolicyTypeTwia.code,
                        }).concat("\n").concat(` (${policyNumber}) - Policy Change (${quoteID})`)
                    );
                } else {
                    setLobWithQuoteNumber(
                        translator({
                            id: `typekey.HOPolicyType_HOE.${hoPolicyTypeTwia.code}`,
                            defaultMessage: hoPolicyTypeTwia.code,
                        }).concat(` Quote (${quoteID || policyNumber})`));
                }
            } else if (hoPolicyTypeTfpa) {
                if (jobType === 'PolicyChange' && !_.isEmpty(jobId)) {
                    setLobWithQuoteNumber(
                        translator({
                            id: `typekey.HOPolicyType_HOE.${wizardSubmission.value.lobData.homeowners_tfpa.coverables_Ext.yourHome.policyType_Ext}`,
                            defaultMessage: wizardSubmission.value.lobData.homeowners_tfpa.coverables_Ext.yourHome.policyType_Ext
                        }).concat("\n").concat(` (${policyNumber}) - Policy Change (${quoteID})`)
                    );
                } else if(jobType === 'PolicyChange' && _.isEmpty(jobId)) {
                    setLobWithQuoteNumber(
                        translator({
                            id: `typekey.HOPolicyType_HOE.${wizardSubmission.value.lobData.homeowners_tfpa.coverables_Ext.yourHome.policyType_Ext}`,
                            defaultMessage: wizardSubmission.value.lobData.homeowners_tfpa.coverables_Ext.yourHome.policyType_Ext
                        }).concat(`- Quote (${quoteID || policyNumber})`)
                    );
                }
                else {
                    setLobWithQuoteNumber(
                        translator({
                            id: `typekey.HOPolicyType_HOE.${wizardSubmission.value.lobData.homeowners_tfpa.policyType_TWIA}`,
                            defaultMessage: wizardSubmission.value.lobData.homeowners_tfpa.policyType_TWIA
                        }).concat(` - Quote (${quoteID || policyNumber})`));
                } 
            }else{
                // DE15839 show header before policy type is selected
                setLobWithQuoteNumber(translator(messages.homeowners, {quoteNumber: quoteID}));
            }
        } else if (productCode === 'CommercialProperty') {
            // DE15784
            const quoteID = _.get(wizardSubmission.value, 'quoteID');
            const policyNumber = _.get(wizardSubmission.value, 'policyNumber');
            const jobId = _.get(wizardSubmission.value, 'jobID')

            if(jobType === 'Renewal'){
                setLobWithQuoteNumber(
                    translator(messages[_.camelCase(lob)], {
                        quoteNumber: quoteID || policyNumber,
                        jobId: _.get(wizardSubmission.value, 'jobID') || '',
                    })
                );
            } else if (jobType === 'PolicyChange' && !_.isEmpty(jobId)) {
                setLobWithQuoteNumber(
                    translator(messages[_.camelCase(lob)], {
                        quoteNumber: quoteID || policyNumber,
                        jobId: _.get(wizardSubmission.value, 'jobID') || '',
                    })
                );
            } else {
                setLobWithQuoteNumber(
                    translator(messages[_.camelCase(lob)], {
                        quoteNumber: quoteID || policyNumber,
                        jobId: _.get(wizardSubmission.value, 'jobID') || '',
                    })
                );
            }

            if (!_.isUndefined(coverageFormList) && coverageFormList.length > 0) {
                const bldgToUpdate = coverageFormList.find(loc => {
                    const {buildings} = loc;

                    return buildings.some(b => b.coverageForm);
                });
            
                if (bldgToUpdate) {
                    const {buildings} = bldgToUpdate;
                    const bldgWithCoverageForm = buildings.find(b => b.coverageForm);

                    if (bldgWithCoverageForm) {
                        setbuildcoverageForm(bldgWithCoverageForm.coverageForm);
                        const policyType = translator({
                            id: `typekey.CoverageForm.${bldgWithCoverageForm.coverageForm}`,
                            defaultMessage: bldgWithCoverageForm.coverageForm,
                        })
                        
                        if(jobType === 'Renewal'){
                            setLobWithQuoteNumber(
                                translator(messages[`${_.camelCase(lob)}PolicyType`], {
                                    policyType,
                                    quoteNumber: quoteID || policyNumber,
                                    jobId: _.get(wizardSubmission.value, 'jobID') || '',
                                })
                            );
                        } else if (jobType === 'PolicyChange' && !_.isEmpty(jobId)) {
                            setLobWithQuoteNumber(
                                translator(messages[`${_.camelCase(lob)}PolicyType`], {
                                    policyType,
                                    quoteNumber: quoteID || policyNumber,
                                    jobId: _.get(wizardSubmission.value, 'jobID') || '',
                                })
                            );
                        }
                        else {
                            setLobWithQuoteNumber(
                                translator({
                                    id: `typekey.CoverageForm.${bldgWithCoverageForm.coverageForm}`,
                                    defaultMessage: bldgWithCoverageForm.coverageForm,
                                }).concat(`- Quote (${quoteID || policyNumber})`)
                            );
                        }
                        
                    }
                }
            }
            
            
        }
    }, [coverageFormList, currentStepIndex, hoPolicyTypeTfpa, hoPolicyTypeTwia, lobFlow, translator, wizardSubmission]);

    const titleContainerClass = cx({
        [styles.gwWizardPageTitle]: !isSideHeader,
        [styles.gwWizardSidePageTitle]: isSideHeader,
    });

    const categoryContainerClass = cx({
        [styles.gwWizardPageCategory]: !isSideHeader,
        [styles.gwWizardSidePageCategory]: isSideHeader,
    });

    const associatedPageClass = cx({
        [styles.gwWizardPageAssociated]: !isSideHeader,
        [styles.gwWizardSidePageAssociated]: isSideHeader,
    });

    const titleSeparator = isSideHeader && (
        <div className={styles.gwWizardSidePageTitleSeparator} />
    );

    // DE15476 attempt to save on cancel, but don't block
    // 2024-12-29 - Debra Frum - US29286 - PE - Common - CANCEL PREVIOUS NEXT SAVE&EXIT - Part 2
    //   Save all transaction types before exiting transaction wizards
    // DE18827
    const saveOnCancel = useCallback(async () => {
        const aspects = wizardSubmission.aspects;
        if (aspects.valid && aspects.subtreeValid) {
            const payload = _.get(wizardSubmission, 'value');
            try {
                const serverCallObj = TWIAWizardHelper.getServerCallObj(wizardSubmission, payload);
                if (Object.keys(serverCallObj).length > 0) {
                    const {serverCall, payloadParam} = serverCallObj;
                    await serverCall(payloadParam, authHeader)
                }

            } catch(e) {
                console.error('unable to save on cancel');
            }
        }
    }, [wizardSubmission]);

    // US28699
    const openPopup = useCallback(
        (event, path) => {
            QuoteExitPopupUtil.quoteExitPopup(event, path, translator, wizardSubmission, showConfirm, saveOnCancel);
        },
        [showConfirm]
    );

    const submissionQuote = wizardHeaderTemplate === 'transaction' && (
        <div className={titleContainerClass}>
            <div className={categoryContainerClass}>
                {translator(messages.accountTitle)}
                <Link className={associatedPageClass} onClick={event => openPopup(event,routePath)} to={routePath}>
                    {accountName}
                </Link>
            </div>
            {titleSeparator}
            {displayWizardHeader ? (
                <h1
                    className={cx(styles.wizardPageHeader, {
                        [styles.gwWizardSidepageTitle]: isSideHeader,
                    })}
                >
                    <span className={styles.pageHeader}>{lobWithQuoteNumber}</span>
                </h1>
            ) : (
                ''
            )}
        </div>
    );

    const claimHeader = useCallback(() => {
        const claimNumber = _.get(wizardSubmission.value, 'claimNumber', '');

        return wizardHeaderTemplate === 'claim' ? (
            <h1 className={styles.gwPageTitle}>
                {translator(messages.fnolNewClaim)}
                <span className={styles.gwClaimsWizardSpanNumber}>
                    {claimNumber}
                </span>
            </h1>
        ) : null;
    }, [wizardHeaderTemplate, translator, wizardSubmission.value]);

    return (
        <React.Fragment>
            {submissionQuote}
            {/* {claimHeader()} */}
        </React.Fragment>
    );
};

WizardPageHeader.propTypes = {
    wizardSubmission: PropTypes.shape({
        value: PropTypes.shape({}),
        _dtoName: PropTypes.string,
    }).isRequired,
    isSideHeader: PropTypes.bool,
    lobFlow: PropTypes.string,
    displayWizardHeader: PropTypes.bool,
};

WizardPageHeader.defaultProps = {
    isSideHeader: false,
    lobFlow: '',
    displayWizardHeader: true,
};

export default WizardPageHeader;
